<template>
<div>
    <div class="menu_bar">
        <router-link :to="{name:menu.ctrl}" v-for="menu in modules" :key="menu.id" class="menu_item" :class="{'selected':menu.id==id}">
            <div :class="`menu_icon icon_${menu.ctrl}`"></div>
            <span class="menu_title">{{$t(`fixed.${menu.ctrl}.title`)}}</span>
        </router-link>
        <router-link :to="{name:'menu'}" :class="{'selected':id==0}" class="menu_item" v-if="!(info.url && info.url!='')">
            <div class="menu_icon icon_game"></div>
            <span class="menu_title">{{$t(`fixed.subjects.title`)}}</span>
        </router-link>
        <a :href="this.info.url" target="_blank" class="menu_item" v-if="info.url && info.url!=''">
            <div class="menu_icon icon_game"></div>
            <span class="menu_title">{{$t(`fixed.subjects.title`)}}</span>
        </a>
    </div>
</div>
</template>  

<script>
export default {
    computed: {
        id() {
            return this.$route.meta.id
        },
        modules() {
            console.log(this.$store.state.game.modules)
            return this.$store.state.game.modules
        },
        info() {
            return this.$store.state.game.info
        }
    }
}
</script>